import {FC} from "react";
import {BaseIcon, IPropsIcon} from "./BaseIcon";

interface IProps extends IPropsIcon {

}

export const PrevArrowIcon: FC<IProps> = ({size = 15, fill = 'none'}) => {
    return (
        <BaseIcon size={size} viewBox="0 0 8 12" fill={fill}>
            <path
                d="M0.589844 5.65234C0.273438 6.00391 0.273438 6.53125 0.589844 6.84766L5.37109 11.6289C5.72266 11.9805 6.25 11.9805 6.56641 11.6289L7.375 10.8555C7.69141 10.5039 7.69141 9.97656 7.375 9.66016L3.96484 6.25L7.375 2.875C7.69141 2.55859 7.69141 1.99609 7.375 1.67969L6.56641 0.871094C6.25 0.554688 5.72266 0.554688 5.37109 0.871094L0.589844 5.65234Z"
                fill="#0D0D0E"
            />
        </BaseIcon>
    )
}